/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FaultGuruRecommendationResponse
 */
export interface FaultGuruRecommendationResponse {
    /**
     *
     * @type {string}
     * @memberof FaultGuruRecommendationResponse
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof FaultGuruRecommendationResponse
     */
    recommendation?: string;
}

/**
 * Check if a given object implements the FaultGuruRecommendationResponse interface.
 */
export function instanceOfFaultGuruRecommendationResponse(
    value: object,
): value is FaultGuruRecommendationResponse {
    return true;
}

export function FaultGuruRecommendationResponseFromJSON(
    json: any,
): FaultGuruRecommendationResponse {
    return FaultGuruRecommendationResponseFromJSONTyped(json, false);
}

export function FaultGuruRecommendationResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): FaultGuruRecommendationResponse {
    if (json == null) {
        return json;
    }
    return {
        description:
            json["description"] == null ? undefined : json["description"],
        recommendation:
            json["recommendation"] == null ? undefined : json["recommendation"],
    };
}

export function FaultGuruRecommendationResponseToJSON(
    value?: FaultGuruRecommendationResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        description: value["description"],
        recommendation: value["recommendation"],
    };
}
